import { Breakpoints, styled } from "@vw-marketing/us-components";

export const StyledFilterZipContainer = styled.div`
${({theme}) =>`
 min-width: 70%;
    .input-text-field {
        background: #FFFFFF;
        border: none;
        padding:0px 0px 0px 36px!important;

    }
    .input-field-icon-button {
        padding-left: 0px;
        padding-right: 0px;
        svg {
            width: 24px;
        }
    }
    .input-text-field, .focus__container , .location-text {
        font-family: ${theme.fonts.headline[200]?.fontFamily};
        font-style: normal;
        font-weight: 400;
        font-size: 16px !important;
        line-height: 36px;
    }
    .location-text__wrapper {
        left: 0px;
        margin-left: 87px;
    }

    @media (min-width: ${Breakpoints.b960}px) {
        max-width: 326px;
        min-width: 33%;

      .input-text-field {
        background: #FFFFFF;
        border: 1px solid #E6E6E6;
        border-radius: 100px;
        padding: 6px 0px 5px 48px !important;
      }

      .input-field-icon-button {
        padding-left: 17px;
        padding-right: 18px;
        svg {
          width: 16px;
        }
      }

      .input-text-field, .focus__container , .location-text {
        font-size: 18px !important;
      }

      .location-text__wrapper {
        left: inherit;
        margin-left:0px;

        .location-text {
          padding-right: 17px;
          right: 17px;
        }
      }
    }
`}
`
